import { createStyles } from "@mantine/emotion";

export default createStyles ( {
	stepTwoWrapper: {
		display       : "flex",
		flex          : 1,
		flexDirection : "column",
		gap           : "1rem"
	},
	rejectedButton: {
		width: "fit-content"
	}
} );